module.exports = __webpack_public_path__ + "img/firmImg.2d300941.png";